import type { ModelSchema } from '@ember-data/store/types';

import type { DSSetup, RecordAttributes, RecordData } from 'webapp-types';

import ApplicationSerializer from 'webapp/serializers/application';

import type RegressorMetricRecord from 'webapp/models/regressor-metric';

// regressors are only exchanged inside a forecast; ForecastSerializer.serialize builds what is sent
export default class RegressorMetricSerializer extends ApplicationSerializer {
	// json is Raw when it comes from BE, Serialized when BufferedModel.toJSON() runs a forecast through normalize
	override normalize(
		typeClass: ModelSchema,
		json: RecordData.RegressorMetric.Raw | RecordData.RegressorMetric.Serialized,
		prop: string | undefined,
	) {
		const { metricSetup, ...data } = json;
		const attributes: Partial<RecordAttributes<RegressorMetricRecord>> & {
			id?: string | number | null;
		} = { ...data };

		if (metricSetup) {
			const normalizedMetricSetup = this.normalizeMetricSetupData(
				metricSetup as DSSetup.MetricSetupData,
			)!;
			attributes.metricSetupKey = normalizedMetricSetup.key;
			attributes.metricSetupSpaceAccessId = normalizedMetricSetup.spaceAccessId;
			attributes.metricSetupDimensions = normalizedMetricSetup.dimensions || [];
			attributes.metricSetupFilters = normalizedMetricSetup.filters || null;
		}

		return super.normalize(typeClass, attributes, prop);
	}
}
